import React, { useEffect, useState } from "react";
import { Select, Button, ConfigProvider } from "antd";
import { useSelector } from "react-redux";

const { Option } = Select;

const CustomSelect = (props) => {
  const { label, options, onSelect, valueKey, nameKey,mode, error } = props;
  // console.log(options)

  // console.log(options,valueKey,nameKey);
  const [selectedValue, setSelectedValue] = useState(null);

  useEffect(() => {
    // Reset the selected value when the options change
    setSelectedValue(null);
  }, [options]);

  const modeselect = useSelector((state) => state.darkMode);

  const { isdarkMode } = modeselect;

  
  return (
    <>
      <div className="flex items-center">
        <label className="pr-3 w-32 text-left ">{label}</label>
        
        <Select
        className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}
          placeholder={`Select ${label}`}
          
          onChange={(value) => {
            setSelectedValue(value);
            onSelect(value);
          }}
          mode={mode}
          value={selectedValue}
          dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
        >
          {options?.map((option) => (  
           
            <Option   key={option[valueKey]} value={option[valueKey]}>
              {option[nameKey]}
              {/* {console.log(option)} */}
            </Option>
          ))}
        </Select>
        {error && <Alert message={`Please select a ${label}`} type="error" />}
      </div>
    </>
  );
};

export default CustomSelect;




